import { easeInOut } from 'motion-v'

export const dialogBackdrop = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 0.4,
    transition: {
      duration: 0.3,
      ease: easeInOut,
    },
  },
}

export const dialogContent = {
  initial: {
    opacity: 0,
    filter: 'blur(10px)',
    z: -100,
    rotateY: 25,
    rotateX: 5,
    transformPerspective: 500,
    transition: {
      duration: 0.3,
      ease: [0.67, 0.17, 0.62, 0.64],
    },
  },
  animate: {
    opacity: 1,
    filter: 'blur(0px)',
    rotateX: 0,
    rotateY: 0,
    z: 0,
    transition: {
      delay: 0.2,
      duration: 0.5,
      ease: [0.17, 0.67, 0.51, 1],
      opacity: {
        delay: 0.2,
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  },
}

export const showChart = {
  initial: {
    height: 0,
    opacity: 0,
    transformOrigin: 'top',
  },
  enter: (delay: number) => ({
    height: '180px',
    opacity: 1,
    transformOrigin: 'top',
    transition: {
      delay: delay,
      duration: 0.2,
      ease: easeInOut,
      staggerChildren: 0.15,
    },
  }),
}
export const scaleBar = {
  initial: {
    height: 0,
    opacity: 0,
  },
  enter: (prop: { height: string, delay: number }) => ({
    height: prop.height,
    opacity: 1,
    transition: {
      delay: prop.delay,
      duration: 0.5,
      ease: easeInOut,
    },
  }),
}
